<!--  -->
<template>
  <div class="page" :class="{ active: isApp || miniprogram }">
    <common-title v-if="!isApp && !miniprogram" titleName="SVIP课程体验" :zIndex="1000"></common-title>
    <div class="nikeName" :class="{active: isApp || miniprogram}">
      用户<span class="nikeNameTxt">{{nikeName}}</span><span class="cl">{{time}}分钟</span>前<span class="cl">已报名</span>暑期SVIP班
    </div>
    <div class="main">
      <span class="main_tag">可体验</span>
      <div class="main_content">
        <div class="main_content_course">
          <h3>课程试听</h3>
          <div class="img_box">
            <img @click="toLearn" class="img" :src="courseDetail.coverMobile" alt="" />
            <div @click="toLearn" class="testLisen">
              <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/player.png" />
              <span>课程试听</span>
            </div>
          </div>
        </div>
        <div class="main_content_server">
          <h3>学习服务</h3>
          <div class="main_content_server_list">
            <div @click="toServer(item.id)" v-for="(item) in serverDesced" :key="item.id" class="server_list_item">
              <img :src="item.icon" />
              <span>{{item.name}}</span>
            </div>
          </div>
        </div>
      </div>
      <div @click="toLearn" class="main_btn">戳我体验</div>
    </div>
    <div class="main other">
      <span class="main_tag">不可体验</span>
      <div class="other_content">
        <div @click="toServer(item.id)" class="other_content_item" v-for="(item) in serverDescWait" :key="item.id">
          <img :src="item.icon"/>
          <span>{{item.name}}</span>
        </div>
      </div>
      <div class="other_-foot">
        <span class="text">此类服务仅购买后享受</span>
        <span @click="openChat" class="btn">立即咨询</span>
      </div>
    </div>
    <div class="recommend">
      <h1 class="title">推荐课程</h1>
      <div>
        <CourseCard v-for="(item, i) in courseList" :key="i" :item="item" :userInfo="userInfo" @showLogin="checkLogin" />
      </div>
    </div>
    <div class="chat" @click="openChat"></div>
    <van-popup v-model="couponVisible" class="getCoupon" :close-on-click-overlay="false">
      <div class="couponBox">
        <img @click="closeVanPopup" class="close" src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/close.png" />
        <p class="pop_p"><span>81%</span>用户选择联报</p>
        <img class="coupon_banner" src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/coupon_banner.png" />
        <div @click="receiveCoupon" class="btn">{{btnText}}</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import { mapState } from 'vuex';
import { reqIsBuyProduct, reqCourseDetail } from '@/api/courseDetail/index';
import {reqCheckCoupon, reqReceiveCoupon} from '@/api/coupon'
import { reqProducts, reqTypeList } from '@/api/home';
import { resetProductData } from '@/utils/tools';
import { getTaskApi } from '@/api/member/index';
import CourseCard from './components/courseCard.vue';
import {nickNameList,couponData,serverDesced,serverDescWait} from './data.js'

export default {
  components: {
    CourseCard,
  },
  data() {
    return {
      isApp: this.$root.$data.isApp,
      miniprogram: this.$root.$data.miniprogram,
      experienceProductId: '',
      learnServiceList: [],
      courseDetail: {},
      buyInfo: [],
      courseList: [],
      nikeName: '',
      time:'',
      setIntervalTiem:'',
      couponVisible:false,
      needCoupon:true,
      btnText:'立即领取',
      hasCoupon: false,
      couponTimer: null,
      serverDesced:[...serverDesced.slice(0,5),{name:'更多服务',icon:'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/svipProduct/serve_icon_013.png',id:99}],
      serverDescWait:serverDescWait,
      commonData:[]
    };
  },
  computed: {
     ...mapState(['userInfo']),
  },
  watch: {},
  methods: {
    closeVanPopup(){
      this.couponVisible = false
    },
    async getTypeList() {
      const res = await reqTypeList('SIVP_PAGEDATA');
      if (res.code === 0) {
        const data = []
        res?.data.forEach(item=>{
          data.push(JSON.parse(item.remark))
        })
        this.commonData = data
      }
    },
    // 查权益
    async getVipCourse() {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      try {
        await this.$root.getUserInfo();
      }catch (e){
        return
      }

      const { subjectType,seaSonModul } = this.$route.query;
      const subjectProductInfo = this.commonData.filter(item => item.subjectType === Number(subjectType))
      const experienceProductId = (Number(seaSonModul) === 1) ? subjectProductInfo[0].seaSonCourse26 : subjectProductInfo[0].seaSonCourse27;
      const reProductList = (Number(seaSonModul) === 1) ? subjectProductInfo[0].recommendCourse26 : subjectProductInfo[0].recommendCourse27
      this.experienceProductId = experienceProductId;
      await this.getCourseSku(experienceProductId);
      this.getCourseList(reProductList);
      this.showNikeName(); // 昵称
      this.reqCouponListFn() // 优惠券相关
      // await this.getDictionary(serviceList, customServicesList);
      this.$toast.clear();
    },
    // 领取优惠券
    async receiveCoupon(){
      if (this.btnText === '立即领取') {
        const { seaSonModul } = this.$route.query;
        const id = couponData[Number(seaSonModul - 1)]
        const res = await reqReceiveCoupon({
          couponId: id,
          couponVersion: 1,
          fitEndPoint: this.$root.$data.isApp ? 2 : 4,
          fitPlatform: 1,
          isPrivateCoupon: 0,
          terminalMark: this.$global.terminalMark,
        });
        if (res?.code === 0) {
          this.btnText = '立即查看'
          this.$toast('领取成功');
        }else {
          this.$toast(res?.msg);
        }
      }else {
        this.$router.push({path: '/personalCenter/myCoupon'});
      }
    },
    // 查询是否领取优惠券
    async reqCouponListFn(){
      const { seaSonModul } = this.$route.query;
      const id = couponData[Number(seaSonModul - 1)]
      const res = await reqCheckCoupon({
        couponId:id,
        couponVersion: 1
      })
      this.hasCoupon = res.data;
      // 没有这张优惠券
      if (!this.hasCoupon) {
        const that = this;
        const couponTimer = setTimeout(()=>{
          that.couponVisible = true
        },60000)
      }
    },
    // 3s随机更换展示昵称
    showNikeName(){
      const that = this;
      const randomNumber = Math.floor(Math.random() * 96) + 1;
      const randomTiem = Math.floor(Math.random() * 20) + 1;
      that.nikeName = nickNameList[randomNumber]
      that.time = randomTiem
      const setIntervalTiem = setInterval(()=>{
        const randomNumber = Math.floor(Math.random() * 96) + 1;
        const randomTiem = Math.floor(Math.random() * 20) + 1;
        that.nikeName = nickNameList[randomNumber]
        that.time = randomTiem
      },3000)
    },
    // 查课程sku
    async getCourseSku(id) {
      const { data } = await reqCourseDetail(id);
      this.courseDetail = data;
    },
    // 查课程列表
    async getCourseList(ids) {
      const endPoint = this.isApp ? 2 : 4;
      const { data } = await reqProducts(ids, endPoint);
      const resCourse = resetProductData(data || []);
      this.courseList = resCourse;
    },
    // 查基础字段北包包
    async getDictionary(serviceList, customServicesList) {
      const { data } = await reqTypeList('VIP_SERVICES');
      const learnServiceArr = data
        .filter((item) => serviceList.some((subItem) => item.code === subItem))
        .map((item) => {
          const { remark, value, code } = item;
          const { title, icon } = JSON.parse(remark);
          return {
            title,
            icon,
            content: value,
            code,
          };
        });
      this.learnServiceList = [...learnServiceArr, ...customServicesList];
    },
    // 去试听
    // 查开课状态
    async checkCourse(id) {
      const { data } = await reqIsBuyProduct(id);
      this.buyInfo = data || [];
      return data || []
    },
    async toLearn() {
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      const checkCourseInfo = await this.checkCourse(this.experienceProductId)
      if (!checkCourseInfo?.length) {
        this.$toast('课程领取中，稍后再试');
        return;
      }
      const { id } = this.buyInfo?.[0];
      const res = await this.entranceTask(id);
      if (res === 'unFinished') {
        if (this.miniprogram) {
          this.$toast('请前往app完成入学任务后，即可查看课程视频');
        } else if (this.isApp) {
          const { origin } = window.location;
          const url = `${origin}/ark/entranceTask?id=${id}`;
          this.$sendToApp('openNewWebView', { url }, false);
        } else {
          this.$router.push({
            path: '/entranceTask',
            query: {
              id,
            },
          });
        }
      } else if (res === 'finished') {
        if (this.$root.miniprogram) {
          wx.miniProgram.navigateTo({ url: `/myCourse/learningGuide/index?catalogId=${id}` });
        } else if (this.$root.$data.isApp) {
          this.$sendToApp('goDirectoryPage', { courseId: id }, false);
        } else {
          this.$router.push({
            path: '/learningGuide',
            query: {
              catalogId: id,
            },
          });
        }
      }
    },
    async entranceTask(id) {
      const { code, data } = await getTaskApi(id);
      if (code === 0) {
        const { agreementId, agreementDone, examId, examDone, examinationFlag, examinationDone } =
          data;
        this.examId = examId;
        if (
          (agreementId && !agreementDone) ||
          (examId && !examDone) ||
          (examinationFlag && !examinationDone)
        ) {
          return 'unFinished';
        }
        return 'finished';
      }
      return 'err';
    },
    // asd
    toServer(i) {
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      this.$router.push({
        path: '/svipExperience',
        query: {
          active: i === 99 ? 1 : i,
          productId: this.experienceProductId
        },
      });
    },
    openChat() {
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      let url = 'https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=689e8f5dbce9490001a460c4';
      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'openNewWebView',
          {
            url,
          },
          false,
        );
        return;
      }
      if (this.$root.miniprogram) {
        const jumpUrl = `/subPackages/webView/webView?url=${encodeURIComponent(url)}`;
        wx.miniProgram.navigateTo({
          url: jumpUrl,
        });
        return;
      }
      window.open(url);
    },
    // 去登录
    toLogin() {
      if (this.isApp) {
        this.$sendToApp('newLogin', {clientType: 38, address:window.location.href}, true);
      } else if (this.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        if (searchParams) {
          const params = searchParams.split('&');
          const paramsMap = new Map();
          params.forEach((item) => {
            const [key, value] = item.split('=');
            //  console.log('key', key, value);
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
          }
          url = `${domain}?${query}`;
          const redirctUrl = encodeURIComponent(
            `/subPackages/detailWebView/index?url=${encodeURIComponent(url)}`,
          );
          const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
          wx.miniProgram.redirectTo({
            url: path,
          });
        }
      } else {
        const param = { redirect: '/svipExperienceProduct', ...this.$route.query };
        this.$router.push({ path: '/registrationLogin', query: param });
      }
    },
    checkLogin(){
      this.toLogin();
    }
  },
  beforeDestroy() {
    this.setIntervalTiem = null
    this.couponTimer = null
  },
  created() {},
  async mounted() {
    document.title = 'SVIP课程体验';
    await this.getTypeList()
    this.getVipCourse();
  },
};
</script>
<style lang="scss" scoped>
.page.active {
  padding-top: 72px;
}
.page {
  max-width: 750px;
  min-height: 100vh;
  margin: 0 auto;
  padding-top: 185px;
  background: #f7f8fc;
  .title {
    padding-bottom: 22px;
    color: #333;
    font-weight: 500;
    font-size: 29px;
    line-height: 40px;
  }
  .main {
    width: 678px;
    margin: 0 auto 22px;
    padding: 43px 29px;
    background: #fff;
    border-radius: 14px;
    position: relative;
    .main_tag{
      display: inline-block;
      width: 105px;
      height: 45px;
      background: #FFEF16;
      border-radius: 0px 14px 0px 14px;
      font-weight: 500;
      font-size: 22px;
      color: #111111;
      line-height: 45px;
      text-align: center;
      position: absolute;
      top: 0;
      right: 0;
    }
    .main_btn{
      width: 609px;
      height: 80px;
      background: #FF7F41;
      border-radius: 49px;
      font-weight: 500;
      font-size: 29px;
      color: #FFFFFF;
      text-align: center;
      margin: 0 auto;
      line-height: 80px;
    }
    .main_content{
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-bottom: 36px;
      .main_content_course{
        width: 268px;
        h3{
          font-weight: 500;
          font-size: 29px;
          color: #333333;
          font-family: PingFangSC, PingFang SC;
        }
        .img_box{
          margin-top: 22px;
          width: 100%;
          height: 250px;
          overflow: hidden;
          position: relative;
          border-radius: 14px;
          .img{
            width: 100%;
          }
          .testLisen{
            width: 100%;
            height: 54px;
            text-align: center;
            position: absolute;
            left: 0;
            bottom: 0;
            background: #F7F8FC;
            border: 2px solid #E8E9F4;
            line-height: 36px;
            img{
              width: 25px;
              height: 25px;
              vertical-align: middle;
              display: inline-block;
              margin-right: 8px;
            }
            span{
              vertical-align: middle;
              display: inline-block;
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 22px;
              color: #FF7F41;
            }
          }
        }
      }
      .main_content_server{
        width: 319px;
        h3{
          font-weight: 500;
          font-size: 29px;
          color: #333333;
          font-family: PingFangSC, PingFang SC;
        }
        .main_content_server_list{
          width: 100%;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          row-gap: 26px;
          margin-top: 22px;
          .server_list_item{
            width: 33.3%;
            text-align: center;
            img{
              width: 72px;
              height: 72px;
              margin-bottom: 11px;
            }
            span{
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 20px;
              color: #333333;
              display: block;
              text-align: center;
            }
          }
        }
      }
    }
  }
  .main.other{
    padding: 0;
    padding-top: 54px;
    .other_content{
      padding: 0 36px;
      display: flex;
      padding-bottom: 0;
      justify-content: space-between;
      .other_content_item{
        width: 33.3%;
        text-align: center;
        img{
          width: 72px;
          height: 72px;
          margin-bottom: 11px;
        }
        span{
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 24px;
          color: #333333;
          display: block;
          text-align: center;
          line-height: 31px;
        }
      }
    }
    .other_-foot{
      width: 100%;
      height: 72px;
      background: linear-gradient(0,#E3EBF9 0%, #F1F6FF 100%);
      border-radius: 0px 0px 11px 11px;
      margin-top: 29px;
      text-align: center;
      line-height: 58px;
      .text{
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 25px;
        color: #333333;
        margin-right: 14px;
        vertical-align: middle;
      }
      .btn{
        display: inline-block;
        width: 123px;
        height: 42px;
        background: #FF7F41;
        border-radius: 21px;
        text-align: center;
        line-height: 42px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 22px;
        color: #FFFFFF;
        vertical-align: middle;
      }
    }
  }
  .server {
    width: 678px;
    margin: 0 auto;
    padding: 29px;
    background: #fff;
    border-radius: 14px;
    .box {
      display: flex;
      flex-wrap: wrap;
      padding-top: 29px;
      .item:nth-child(5n) {
        margin-right: 0;
      }
      .item {
        width: 120px;
        margin: 0 5px 22px 0;
        img {
          display: block;
          width: 72px;
          height: 72px;
          margin: 0 auto;
        }
        p {
          padding-top: 11px;
          color: #333;
          font-weight: 400;
          font-size: 22px;
          text-align: center;
        }
      }
    }
  }
  .recommend {
    width: 678px;
    margin: 22px auto;
    padding: 29px;
    background: #fff;
    border-radius: 14px;
  }
  .chat {
    position: fixed;
    right: 0;
    bottom: 300px;
    width: 127px;
    height: 109px;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/kefu2.png');
    background-size: 100%;
  }
  .nikeName{
    width: 750px;
    height: 51px;
    background: #FFEDDD;
    text-align: center;
    line-height: 51px;
    font-size: 25px;
    position: fixed;
    left: 0;
    top: 100px;
    z-index: 13;
    .nikeNameTxt{
      margin: 0 4px;
    }
    .cl{
      color: rgba(255, 26, 63, 1);
    }
  }
  .nikeName.active{
    top: 0;
  }
  .getCoupon{
    width: 634px;
    height: 737px;
    background: url("https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/chat_bg.png") no-repeat;
    background-size: 100%;
    background-position: top left;
    background-color: #ffffff;
    border-radius: 36px;
  }
  .couponBox{
    position: relative;
    width: 100%;
    box-sizing: border-box;
    padding-top: 83px;
    text-align: center;
    .close{
      width: 29px;
      height: 29px;
      position: absolute;
      top: 40px;
      right: 40px;
    }
    .pop_p{
      font-weight: 500;
      font-size: 33px;
      color: rgba(51, 51, 51, 1);
      text-align: center;
      span{
        color: #FF7F41;
      }
    }
    .coupon_banner{
      width: 540px;
      margin-top: 22px;
    }
    .btn{
      width: 330px;
      height: 80px;
      background: #FF7F41;
      border-radius: 45px;
      line-height: 80px;
      text-align: center;
      font-weight: 500;
      font-size: 29px;
      color: #FFFFFF;
      margin: 0 auto;
      margin-top: 36px;
    }
  }
}
</style>
